import { motion } from "framer-motion";
import { Phone, ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useQuote } from "@/context/QuoteContext";
import { SITE } from "@/data/site";

export const FinalCTA = () => {
  const { openQuote } = useQuote();

  return (
    <section id="contact" data-testid="final-cta-section" className="py-16 sm:py-20 lg:py-28 bg-gradient-to-br from-red-700 to-red-800">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 border border-white/20 px-4 py-1.5 mb-6">
            <ShieldCheck className="h-4 w-4 text-white" />
            <span className="text-xs sm:text-sm font-bold tracking-wide text-white uppercase">Trusted Since 1980</span>
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white text-balance">
            Ready to Protect Your Property? Get Your Free Quote Today.
          </h2>
          <p className="mt-5 text-lg text-red-50 max-w-2xl mx-auto leading-relaxed">
            No pressure. No obligation. Just honest, owner-verified guidance from California's most reliable
            roofing & construction team. It takes under 60 seconds to start.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              data-testid="final-quote-btn"
              onClick={() => openQuote()}
              size="lg"
              className="bg-slate-950 hover:bg-slate-800 text-white font-bold rounded-full h-14 px-8 hover:scale-105 transition-transform"
            >
              Get My Free Quote <ArrowRight className="ml-1 h-5 w-5" />
            </Button>
            <a href={SITE.phoneHref} data-testid="final-call-btn">
              <Button size="lg" className="w-full sm:w-auto bg-white text-red-800 hover:bg-red-50 font-bold rounded-full h-14 px-8 hover:scale-105 transition-transform">
                <Phone className="mr-1 h-5 w-5" /> Call {SITE.phone}
              </Button>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
